import React, { useCallback, useMemo } from "react";
import cx from "classnames";
import * as Scrivito from "scrivito";
import { Button, Icon } from "components";
import { projectTranslations } from "config/locals/projectTranslations";

import { useTranslate } from "hooks";
import s from "./FilterBtn.module.scss";

function FilterBtnComponent({
  name,
  count,
  color,
  icon,
  iconPrefix,
  isActive,
  onClick,
  disabled,
  id,
}) {
  const translate = useTranslate();
  const handleClick = useCallback(() => {
    onClick(name);
  }, [name, onClick]);

  const translateProp = useMemo(
    () => (name ? `PROJECT_STATUS_${name}` : ""),
    [name],
  );

  // check for Scrivito edit mode
  const getNameText = (filterName) => {
    if (typeof filterName === "string") {
      return filterName.replace(/-+/g, "_");
    }

    if (filterName && typeof filterName === "object" && filterName.props) {
      return filterName.props.tooltipText || filterName.props.text || "";
    }

    return "";
  };

  const filterName = projectTranslations[translateProp.toUpperCase()]
    ? translate(translateProp)
    : translate(getNameText(id));

  return (
    <Button
      data-testid={translateProp}
      color="filter"
      active={isActive}
      onClick={handleClick}
      className={cx(
        s.filterBtn,
        {
          [s.checked]: isActive,
          "border-gray-300 bg-white": disabled,
        },
        "text-nowrap",
      )}
      square={true}
      disabled={disabled}
    >
      {color && (
        <div
          className={cx("mr-2 rounded-circle icon-12")}
          style={{ background: color }}
        />
      )}
      {icon && <Icon iconName={icon} prefix={iconPrefix} />}
      {filterName}
      {(!!count || +count === 0) && ` (${count})`}
    </Button>
  );
}

const ConnectedFilterBtn = Scrivito.connect(FilterBtnComponent);
export const FilterBtn = React.memo(
  ConnectedFilterBtn,
  (prevProps, nextProps) => {
    if (prevProps.name === nextProps.name) {
      return false;
    }
    return true;
  },
);
